<script setup>
import {defineProps} from "vue";

const props = defineProps({
    stat: Object
});
</script>

<template>
    <div class="mb-10 lg:mb-24 grid grid-cols-2 lg:grid-cols-4" v-if="stat">
        <div class="bg-blue-700 py-12 text-center font-sans text-white border lg:border-0 border-r-0 border-blue-400">
            <h2 class="text-5xl lg:text-6xl font-extralight">{{ props.stat.assigned_to_me }}</h2>
            <p class="text-xs lg:text-sm">{{ $tt('my_portal_stat__assigned_to_me', props.stat.assigned_to_me) }}</p>
        </div>
        <div
            class="bg-blue-600 py-12 text-center font-sans text-white border lg:border-0 border-l-0 border-r-0 border-blue-400">
            <h2 class="text-5xl lg:text-6xl font-extralight">{{ props.stat.in_progress }}</h2>
            <p class="text-xs lg:text-sm">{{ $tt('my_portal_stat__in_progress', props.stat.in_progress) }}</p>
        </div>
        <div
            class="bg-blue-800 py-12 text-center font-sans text-white border lg:border-0 border-t-0 border-l-0 border-r-0 border-blue-400">
            <h2 class="text-5xl lg:text-6xl font-extralight">{{ props.stat.completed }}</h2>
            <p class="text-xs lg:text-sm">{{ $tt('my_portal_stat__completed', props.stat.completed) }}</p>
        </div>
        <div
            class="bg-blue-900 py-12 text-center font-sans text-white border lg:border-0 border-t-0 border-r-0 border-blue-400">
            <h2 class="text-5xl lg:text-6xl font-extralight">{{ props.stat.not_started }}</h2>
            <p class="text-xs lg:text-sm">{{ $tt('my_portal_stat__not_started', props.stat.not_started) }}</p>
        </div>
    </div>
</template>